import { connect } from 'react-redux';
import CancelSubscriptionModal from './CancelSubscriptionModal';
import { cancelSubscriptionThunk } from '../../../store/billing/billing.thunks';
import { hideModal } from '../../../store/modal/modal.actions';

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = dispatch => ({
  onClickOk: () => {
    dispatch(cancelSubscriptionThunk());
  },
  onClickCancel: () => {
    dispatch(hideModal());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CancelSubscriptionModal);
